import { render, staticRenderFns } from "./ComprometimentosFaturamento.vue?vue&type=template&id=c7ab381c"
import script from "./ComprometimentosFaturamento.vue?vue&type=script&lang=js"
export * from "./ComprometimentosFaturamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports